import { render, staticRenderFns } from "./RewardsDisclaimer.vue?vue&type=template&id=7d8d7635&scoped=true&"
import script from "./RewardsDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./RewardsDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./RewardsDisclaimer.vue?vue&type=style&index=0&id=7d8d7635&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8d7635",
  null
  
)

export default component.exports